"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileAccountInfoSection = void 0;
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const user_statuses_1 = require("@Const/user-statuses");
const navigation_1 = __importDefault(require("@App/navigation"));
const CustomToolTip_1 = __importDefault(require("@Components/CustomToolTip"));
require("./index.scss");
const ProfileAccountInfoSection = (props) => {
    const { userInfo, getVerified } = props;
    const isInternal = userInfo && userInfo.isInternalUser;
    return (react_1.default.createElement("section", { className: "account-info-section" },
        react_1.default.createElement("h5", null, "Account Info"),
        react_1.default.createElement("div", { className: 'fields-row-container nowrap' },
            react_1.default.createElement("div", { className: 'field-block' },
                react_1.default.createElement("p", { className: 'small title' }, "Password"),
                react_1.default.createElement("p", { className: 'value' }, "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022")),
            react_1.default.createElement("div", { className: 'field-block bottom-align' },
                react_1.default.createElement(react_router_dom_1.Link, { to: navigation_1.default.profile.changePassword(), className: 'link' }, "Change Password"))),
        react_1.default.createElement("div", { className: 'fields-row-container nowrap verified-row' },
            react_1.default.createElement("div", { className: 'field-block verified-block' },
                react_1.default.createElement("p", null, "Verification status: \u00A0"),
                react_1.default.createElement("strong", null, userInfo === null || userInfo === void 0 ? void 0 : userInfo.verificationStatus)),
            react_1.default.createElement("div", { className: 'field-block bottom-align' }, !isInternal &&
                getVerified &&
                userInfo &&
                userInfo.verificationStatus !== user_statuses_1.USER_VERIFICATION_STATUSES.VERIFIED && (react_1.default.createElement("span", { className: "line" }, props.isRunningKyc ? (react_1.default.createElement("i", null, "Verifying, please wait...")) : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("p", { onClick: getVerified, className: 'link blue-text' }, "Get Verified"),
                react_1.default.createElement(CustomToolTip_1.default, { type: '?', info: 'Adding members requires a higher level of account access that is subject to a verification step. Please visit' +
                        ' your Account Info on your Profile page and click on Get Verified.' })))))))));
};
exports.ProfileAccountInfoSection = ProfileAccountInfoSection;
